type ViewMode = 'list' | 'board';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onChange: (viewMode: ViewMode) => void;
}

export function ViewModeToggle({ viewMode, onChange }: ViewModeToggleProps) {
  return (
    <div className="view-mode-toggle" role="group" aria-label="Task view mode">
      <button
        type="button"
        className={`view-mode-button${viewMode === 'list' ? ' active' : ''}`}
        onClick={() => onChange('list')}
        aria-pressed={viewMode === 'list'}
      >
        List view
      </button>
      <button
        type="button"
        className={`view-mode-button${viewMode === 'board' ? ' active' : ''}`}
        onClick={() => onChange('board')}
        aria-pressed={viewMode === 'board'}
      >
        Board view
      </button>
    </div>
  );
}